import Link from 'next/link';
import { ReactNode } from 'react';

import { Tabs } from '@shared/ui';

import { useProfileSecurityTabsConfig } from '../../model';

export const ProfileSecurityDesktopLayout = ({ children }: { children: ReactNode }) => {
  const { tabsConfig, activeTab } = useProfileSecurityTabsConfig();

  return (
    <>
      <div className='flex h-[66px] items-center px-[20px] font-semibold text-[18px]'>امنیت</div>
      <Tabs className='flex-1' key={activeTab} defaultValue={activeTab} varient='line'>
        <Tabs.List>
          {tabsConfig.map((tab) => (
            <Tabs.Trigger key={tab.id} value={tab.id} className='p-0'>
              <Link href={tab.href} className='w-full h-full flex items-center gap-1'>
                {tab.icon}
                {tab.label}
              </Link>
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {children}
      </Tabs>
    </>
  );
};
